import React from 'react';

import CustomModal from '../../components/CustomModal';
import { CrossIcon, ErrorIcon } from '../../assets/icons';
import Button from '../../components/Button';
import useModalState from '../../context/modal/useModalState';

const ErrorModal: React.FC = () => {
    const { modalData, closeModal } = useModalState();
    const onClose = () => closeModal('errorModal');

    return (
        <CustomModal
            modalName='errorModal'
            className='error-modal status-modal'
            overlayClassName='status-modal'
        >
            <div className='content'>
                <Button onClick={onClose}>
                    <CrossIcon />
                </Button>
                <div className='icon-container'>
                    <ErrorIcon />
                </div>
                <div className='status'>Error!</div>
                <div
                    className='message'
                    dangerouslySetInnerHTML={{ __html: modalData.message }}
                />
            </div>
        </CustomModal>
    );
};

export default ErrorModal;
